import { render, staticRenderFns } from "./detailList.vue?vue&type=template&id=ffea6436&scoped=true"
import script from "./detailList.vue?vue&type=script&lang=js"
export * from "./detailList.vue?vue&type=script&lang=js"
import style0 from "./detailList.vue?vue&type=style&index=0&id=ffea6436&prod&lang=scss&scoped=true"
import style1 from "./detailList.vue?vue&type=style&index=1&id=ffea6436&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffea6436",
  null
  
)

export default component.exports